
import { setStepDetailProps as setStepDetailPropsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    from?: string;
    to?: string;
}

export const setStepDetailProps = ({
    from,
    to,
}: Props) => setStepDetailPropsDiagram({
    from,
    to,
});


